import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InspectionPointListComponent, InspectionPointListWithDateComponent } from './shared/components/points/list.component';
import { SharedModule } from './shared.module';

@NgModule({
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule, ScrollingModule, SharedModule],
  declarations: [InspectionPointListComponent, InspectionPointListWithDateComponent],
  exports: [InspectionPointListComponent, InspectionPointListWithDateComponent],
  providers: []
})
export class BrowserSharedModule {}
